import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../../../components/global/modal/withModal';
import {
  getAlbumCustomPrintName,
  getAlbumCustomPrintPrice,
} from '../../../../../../../../../util/custom-prints';
import AddedToCartLabel from '../../../PhotoPurchasingOptions/AddedToCartLabel';
import PriceDisplay from '../../../../../../../../../components/global/PriceDisplay';
import Button from '../../../../../../../../../components/global/Button';
import PhotosIcon from '../../../../../../../../../components/icons/PhotosIcon';
import { isAlbumCustomPrintConfigurableInPlace } from '../../helpers';
import { CUSTOM_PRINT_SUBTYPE } from '../../../../../../../../../constants/pro-custom-prints';

const propTypes = {
  className: PropTypes.string,
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    custom_print: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      preview_image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
  onAlbumCustomPrintToggle: PropTypes.func.isRequired,
  albumCustomPrintInCart: PropTypes.bool.isRequired,
  shouldDiscount: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  disableSelection: PropTypes.bool,
};

const AlbumCustomPrintPreviewModal = ({
  className,
  albumCustomPrint,
  onAlbumCustomPrintToggle,
  albumCustomPrintInCart,
  shouldDiscount,
  onClose,
  disableSelection,
}) => {
  const classes = classNames({
    'custom-print-preview-modal-content': true,
    [className]: !!className,
  });

  const name = getAlbumCustomPrintName(albumCustomPrint);
  const price = getAlbumCustomPrintPrice(albumCustomPrint);
  const discountPrice = getAlbumCustomPrintPrice(albumCustomPrint, true);
  const previewImageSrc = albumCustomPrint.custom_print.preview_image.url;
  const customPrintSubtype = albumCustomPrint.custom_print.subtype;

  return (
    <div className={classes}>
      <div className="text-center">
        <img
          src={previewImageSrc}
          alt={`${name} preview`}
          className="custom-print-preview-modal-image"
        />
      </div>

      {!isAlbumCustomPrintConfigurableInPlace(albumCustomPrint) &&
        customPrintSubtype !== CUSTOM_PRINT_SUBTYPE.SPECIALTY_PRINT && (
          <p className="custom-print-preview-modal-photos-note">
            <PhotosIcon size={22} />
            <span className="text-bold">
              You&rsquo;ll be able to pick your {albumCustomPrint.photos_no}{' '}
              favorite pics for your {name.toLowerCase()} after checkout.
            </span>
          </p>
        )}

      {!disableSelection && (
        <Button
          btnStyle={classNames({
            yellow: !albumCustomPrintInCart,
            info: albumCustomPrintInCart,
          })}
          btnSize="lg"
          btnBlock
          className={classNames({
            'text-extra-bold': true,
            'btn-purchase-options-in-cart': albumCustomPrintInCart,
          })}
          onClick={() => {
            onAlbumCustomPrintToggle();
            onClose();
          }}
          data-testid="btn-album-custom-print"
        >
          <span className="pointer-events-none">
            {albumCustomPrintInCart && <AddedToCartLabel />}
            {!albumCustomPrintInCart &&
              (isAlbumCustomPrintConfigurableInPlace(albumCustomPrint) ? (
                <Fragment>Select your photos</Fragment>
              ) : (
                <Fragment>
                  Add to cart &ndash;{' '}
                  <PriceDisplay
                    price={
                      shouldDiscount && !!discountPrice ? discountPrice : price
                    }
                    oldPrice={price}
                    showDiscount={shouldDiscount}
                    animatedStrikethrough
                  />
                </Fragment>
              ))}
          </span>
        </Button>
      )}

      <Button
        btnBlock
        btnStyle="link"
        onClick={onClose}
        className="text-center"
      >
        Dismiss
      </Button>
    </div>
  );
};

AlbumCustomPrintPreviewModal.propTypes = propTypes;

export default withModal(AlbumCustomPrintPreviewModal, {
  size: 'xs',
  hideHeader: true,
});
